// eslint-disable-next-line @exodus/restricted-imports/prefer-basic-utils
import { memoize } from 'lodash';
import { createSelector } from 'reselect';

import createAssetSourceActivitySelector from './asset-source-activity.js';
import type { ActivityItem } from '../types.js';

type CreateAssetSourceActivityByIdSelectorParams = {
  assetName: string;
  walletAccount: string;
};

const createAssetSourceActivityByIdSelector = memoize(
  ({ assetName, walletAccount }: CreateAssetSourceActivityByIdSelectorParams) =>
    createSelector(
      createAssetSourceActivitySelector({ assetName, walletAccount }),
      (activity) =>
        activity.reduce(
          (activityById, activityItem) => {
            activityById[activityItem.id] = activityItem;
            return activityById;
          },
          Object.create(null) as { [txId: string]: ActivityItem },
        ),
    ),
  ({ assetName, walletAccount }) => `${assetName}_${walletAccount}`,
);

export default createAssetSourceActivityByIdSelector;
